
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ButtonSecondary extends Vue {

	@Prop()
	content: string

	@Prop({default:false})
	disabled: boolean

	handleSubmit() {
		this.$emit('handleSubmit');
	}
}
